/** popup logic */
function openPopup() {
  document.getElementById('popup').classList.add("open");
  document.getElementById('overlay').classList.add("open");
  document.documentElement.classList.add("lock-all");
}

function closePopup() {
  document.getElementById('popup').classList.remove("open");
  document.getElementById('overlay').classList.remove("open");
  document.documentElement.classList.remove("lock-all");
}

var openButtons = document.querySelectorAll('.open-popup');
openButtons.forEach(function (button) { 
  button.addEventListener('click', function () {
    const productData = JSON.parse(this.getAttribute('data-product'));
    const firstAvailable = productData.variants.find(function (variant) {
      return variant.available === true;
    });
    const formattedPrice = formatMoney(firstAvailable.price, window.money_format);

    document.getElementById('popup_image').innerHTML = `<img src="${productData.featured_image}">`;
    document.getElementById('popup_product_vendor').innerHTML = `${productData.vendor}`;
    document.getElementById('popup_product_title').innerHTML = `${productData.title}`;
    document.getElementById('popup_product_price').innerHTML = `${formattedPrice}`;
    document.getElementById('popup_option_name').innerHTML = `${productData.options[0]}:`;
    document.getElementById('popup_option_value').innerHTML = `${productData.variants.find(variant => variant.available === true).title}`;

    const popupSelector = document.getElementById('popup_selector');
    let firstAvailableFound = false;
    const optionsHTML = productData.variants.map(function (variant) {
      if (variant.available && !firstAvailableFound) {
        firstAvailableFound = true;
        return `
          <div class="block-swatch">
            <input class="block-swatch__radio visually-hidden" type="radio" name="variant" value="${variant.id}" id="${variant.id}" checked="checked">
            <label class="block-swatch__item" for="${variant.id}">${variant.title}</label>
          </div>`;
      } else if (variant.available) {
          return `
            <div class="block-swatch">
              <input class="block-swatch__radio visually-hidden" type="radio" name="variant" value="${variant.id}" id="${variant.id}">
              <label class="block-swatch__item" for="${variant.id}">${variant.title}</label>
            </div>`;
      } else {
        return `
          <div class="block-swatch is-disabled">
            <input class="block-swatch__radio visually-hidden" type="radio" name="variant" value="${variant.id}" id="${variant.id}">
            <label class="block-swatch__item" for="${variant.id}">${variant.title}</label>
          </div>`;
      }
    }).join('');

    popupSelector.innerHTML = `<div class="block-swatch-list">${optionsHTML}</div>`;

    productData.selectedId = productData.variants.find(function (variant) {
      return variant.available === true;
    }).id;

    productData.selectedName = productData.variants.find(function (variant) {
      return variant.available === true;
    }).name;

    const radioButtons = document.querySelectorAll('#popup_selector input[name="variant"]');

    radioButtons.forEach(radioButton => {
      radioButton.addEventListener('change', function () {
        const addConfiguratorButton = document.querySelector('.add-configurator');
        const soldoutButton = document.querySelector('.popup_soldout');
        const selectedVariant = this.value;

        const fullVariant = productData.variants.find(function (variant) {
          return variant.id == selectedVariant;
        });

        productData.selectedId = selectedVariant;

       // console.log(productData);
        document.getElementById('popup_option_value').innerHTML = `${fullVariant.title}`;

        const formattedVariantPrice = formatMoney(fullVariant.price, window.money_format);
        document.getElementById('popup_product_price').innerHTML = `${formattedVariantPrice}`;

        if (!fullVariant.available) {
          addConfiguratorButton.style.display = 'none';
          soldoutButton.style.display = 'block';
        } else {
          addConfiguratorButton.style.display = 'block';
          soldoutButton.style.display = 'none';
        }

        const productDataString = JSON.stringify(productData);
        addConfiguratorButton.setAttribute('data-product', productDataString);
      });
    });

    const productDataString = JSON.stringify(productData);
    document.querySelector('.add-configurator').setAttribute('data-product', productDataString);
    if(document.querySelector('.view-configurator')) {
      if (document.documentElement.lang === 'de') {
        const productUrl = '/products/' + productData.handle;
        document.querySelector('.view-configurator').setAttribute('href', productUrl);
      } else {
        const productUrl = '/' + document.documentElement.lang + '/products/' + productData.handle;
        document.querySelector('.view-configurator').setAttribute('href', productUrl);
      }
    }

    openPopup()
  });
});
/** close popup */

document.getElementById('close-popup')?.addEventListener('click', closePopup);
document.getElementById('overlay')?.addEventListener('click', closePopup);

// set quantity logic
function checkedQuantity(cart) {
  if (cart.item_count === 0) {
    setQuantity = 1;
  } else {
    cart.items.forEach(item => {
      if (item.properties['Set']) {
        if (+item.properties['Set'] >= setQuantity) {
            setQuantity = +item.properties['Set'] + 1;
        }
      }
    });
  }
}

/** add button */
let setQuantity = sessionStorage.getItem('setQuantity');
if (setQuantity === null || setQuantity === undefined || setQuantity === 'NaN') {
  fetch('/cart.js', {
    method: 'GET',
    cache: 'no-store',
    headers: {
        'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
    }
    return response.json();
  })
  .then(cart => {
    // whatever you want to do with the cart obj
    //console.log(cart);
    checkedQuantity(cart)
  })
  .catch(error => {
    //console.error('There was a problem with the fetch operation:', error);
  });
} else {
  setQuantity = parseInt(setQuantity);
}

const addButton = document.querySelector('.add-configurator');

if (addButton) { 
  addButton.addEventListener('click', function () {
    let currentStep;
    let sessionStorageData = JSON.parse(sessionStorage.getItem(currentStep)) || [];
    const productData = JSON.parse(this.getAttribute('data-product'));
    const productTags = productData.tags || [];

    if (productTags.includes('Set Snowboard')) {
      currentStep = 'step_1';
      this.href = window.setLinks[1];
    } else if (productTags.includes('Set Bindings')) {
      currentStep = 'step_2';
      this.href = window.setLinks[2];
    } else if (productTags.includes('Set Boots')) {
      currentStep = 'step_3';
      this.href = window.setLinks[3];
    } else if (productTags.includes('Set Other')) {
      currentStep = 'step_4';
      this.href = window.setLinks[3];
    } else {
      //console.log('Fix product tags');
      return;
    }
    sessionStorageData = [productData];
    sessionStorage.setItem(currentStep, JSON.stringify(sessionStorageData));
      
    updateConfiguratorList();
  });
}

const addButtonsPlp = document.querySelectorAll('.add-configurator-plp');

addButtonsPlp.forEach(button => {
  button.addEventListener('click', function () {
    let currentStep;
    let sessionStorageData = JSON.parse(sessionStorage.getItem(currentStep)) || [];
    const productData = JSON.parse(this.getAttribute('data-product'));
    const productTags = productData.tags || [];
    productData.selectedId = productData.variants.find(function (variant) {
      return variant.available === true;
    }).id;
    
    if (productTags.includes('Set Snowboard')) {
      currentStep = 'step_1';
      this.href = window.setLinks[1];
    } else if (productTags.includes('Set Bindings')) {
      currentStep = 'step_2';
      this.href = window.setLinks[2];
    } else if (productTags.includes('Set Boots')) {
      currentStep = 'step_3';
      this.href = window.setLinks[3];
    } else if (productTags.includes('Set Other')) {
      currentStep = 'step_4';
      this.href = window.setLinks[3];
    } else {
      //console.log('Fix product tags');
      return;
    }
    
    sessionStorageData = [productData];
    sessionStorage.setItem(currentStep, JSON.stringify(sessionStorageData));
      
    updateConfiguratorList();
    //console.log('added');
  })
});

/** format money */

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function updateConfiguratorList() {
  let setPrice = 0;
  let originalPrice = 0;

  for (let i = 1; i <= 4; i++) {
    const sectionId = 'step_' + i;
    const sessionStorageData = JSON.parse(sessionStorage.getItem(sectionId)) || [];
    const clearBlock = document.querySelector('.' + sectionId + ' .clear');
    const fullBlock = document.querySelector('.' + sectionId + ' .full');

    if (sessionStorageData.length !== 0) {
      const productImage = document.querySelector('.' + sectionId + ' .full__image');
      const productTitle = document.querySelector('.' + sectionId + ' .full__title');
      const productVariant = document.querySelector('.' + sectionId + ' .full__variant');
      const editButton = document.querySelector('.' + sectionId + ' .full__edit');
      const setPriceSpan = document.querySelector('.set_price');
      const origPriceSpan = document.querySelector('.orig_price');
      const freeBadge = document.querySelector('.' + sectionId + ' .full__badge');

      sessionStorageData.forEach(function (product) {
        let selectedVariant
        if (product.variants.length === 1) {
          selectedVariant = product.variants[0]
        } else {
          selectedVariant = product.variants.find(function (variant) {
            return variant.id == product.selectedId;  
          });
        }

        setPrice += selectedVariant.price;
        originalPrice += selectedVariant.compare_at_price;
        let imageHtml = `
          <img width="104" height="104" src="${product.featured_image}" class="" />
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
              d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
              fill="#333333" />
            <path d="M11 17L14 20L21 13" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        `
          if (productImage) {
            productImage.innerHTML = imageHtml;
          }

          if (product.price < 1) {
            freeBadge.style.display = 'block'
          }

          if (productTitle) {
            productTitle.textContent = product.title;
          }
          if (!product.selectedId && productVariant) {
            productVariant.textContent = product.variants.find(function (variant) {
              return variant.available === true;
            }).title;
          } else if (productVariant) {
            productVariant.textContent = selectedVariant.title;
          }
          const escapedProductData = JSON.stringify(product);

          if (editButton) {
            editButton.setAttribute('data-product', escapedProductData);
          }

          if (clearBlock && fullBlock) {
            clearBlock.style.display = 'none';
            fullBlock.style.display = 'flex';
          }
      });
      if (setPriceSpan && origPriceSpan) {
        setPriceSpan.textContent = `${formatMoney(setPrice, window.money_format)}`;
        origPriceSpan.textContent = `${formatMoney(originalPrice, window.money_format)}`
      }
    } else {
        if (clearBlock && fullBlock) {
          fullBlock.style.display = 'none';
          clearBlock.style.display = 'flex'
        }
      }
  }

  if (sessionStorage.getItem('step_1') || sessionStorage.getItem('step_2') || sessionStorage.getItem('step_3') || sessionStorage.getItem('step_4')) {
    document.querySelector('.configurator-footer').style.display = 'flex';
  } else {
    document.querySelector('.configurator-footer').style.display = 'none';
  }

  function checkItems() {
    let productsStorage = 0;
    for (let i = 1; i <= 4; i++) {
      const key = `step_${i}`;
      const value = sessionStorage.getItem(key);

      if (value) {
        const parsedObject = JSON.parse(value);

        let selectedVariant
        if (parsedObject[0].selectedId) {
          selectedVariant = parsedObject[0].variants.find(function (variant) {
            return variant.id == parsedObject[0].selectedId;  
          });
          
        } else {
          selectedVariant = parsedObject[0].variants[0]
        }

        if (selectedVariant.price > 1) {
          productsStorage += 1;
        }
      }
    }

  //console.log(productsStorage, sessionStorage.getItem('step_1'), sessionStorage.getItem('step_2'))
    if (productsStorage >= 2 && sessionStorage.getItem('step_1') && sessionStorage.getItem('step_2')) {
      document.querySelector('.set-add-button').style.display = 'flex';
      document.querySelector('.configurator-footer__message').style.display = 'block';
    } else {
      document.querySelector('.set-add-button').style.display = 'none';
      document.querySelector('.configurator-footer__message').style.display = 'none';
    }
  }

  checkItems();
}

const deleteButtons = document.querySelectorAll('.full__delete');
deleteButtons.forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    const step = button.getAttribute('data-step');

    sessionStorage.removeItem('step_' + step);
    updateConfiguratorList();
  });
});

function addToCart() {
  let formData = {
    items: []
  };

  let setPrice = 0;

  for (var i = 1; i <= 4; i++) {
    const stepData = sessionStorage.getItem('step_' + i);
    if (stepData) {
      const productData = JSON.parse(stepData);
      formData.items.push({id: productData[0].selectedId, properties: {
						'Set': `${setQuantity}`,
					}});
      setPrice += productData[0].price;
    }
  }

  const setPriceFormatted = formatMoney(setPrice, window.money_format)
  const storageKey = `set-price-${setQuantity}`;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      setQuantity += 1;
      sessionStorage.setItem('setQuantity', setQuantity);
      sessionStorage.setItem(storageKey, setPriceFormatted);
      sessionStorage.removeItem('step_1');
      sessionStorage.removeItem('step_2');
      sessionStorage.removeItem('step_3');
      sessionStorage.removeItem('step_4');
      window.location.href = window.themeVariables.routes.cartUrl;
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

updateConfiguratorList();